import { FontSearch } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Font/FontList/FontSearch/FontSearch";
import { GoogleFonts } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Font/FontList/GooleFonts/GoogleFonts";
import { RecentlyUsedFonts } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Font/FontList/RecentlyUsedFonts/RecentlyUsedFonts";
import { SelectedFont } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Font/FontList/SelectedFont/SelectedFont";
import { useFontList } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Font/FontList/useFontList";
import { WebFonts } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Font/FontList/WebFonts/WebFonts";
import { useFont } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/Font/useFont";
import { filterGoogleFonts } from "store/features/memeGenerator/filterGoogleFonts";
import { filterWebFonts } from "store/features/memeGenerator/filterWebFonts";
import { TextBox } from "store/features/memeGenerator/types";

interface ContentProps {
    textBox: TextBox;
    useFontReturn: ReturnType<typeof useFont>;
    useFontListReturn: ReturnType<typeof useFontList>;
}

export const Content = ({ textBox, useFontReturn, useFontListReturn }: ContentProps) => {
    const { loadedFonts } = useFontReturn;
    const {
        search,
        handleSearch,
        recentlyUsedFonts,
        isLoadingRecentlyUsedFonts,
        handleClick,
        webFonts,
        searchedGoogleFonts,
        isLoadingMore,
    } = useFontListReturn;

    return (
        <div className="flex flex-col h-full max-h-full text-black dark:text-white">
            <FontSearch search={search} handleSearch={handleSearch} />
            <SelectedFont fontFamily={textBox.fontFamily} />
            <RecentlyUsedFonts
                recentlyUsedFonts={recentlyUsedFonts}
                isLoadingRecentlyUsedFonts={isLoadingRecentlyUsedFonts}
                search={search}
                handleClick={handleClick}
            />
            <WebFonts
                webFonts={filterWebFonts(webFonts, recentlyUsedFonts, textBox.fontFamily)}
                handleClick={handleClick}
            />
            <GoogleFonts
                googleFonts={filterGoogleFonts({
                    search,
                    searchedGoogleFonts,
                    allGoogleFonts: loadedFonts,
                    recentlyUsedFonts,
                    fontFamily: textBox.fontFamily,
                })}
                handleClick={handleClick}
                isLoadingMore={isLoadingMore}
            />
        </div>
    );
};
